const steps = (lower: number, upper: number, totalSteps: number) => {
  const difference = upper - lower;
  const increment = difference / (totalSteps - 1);

  return [lower, ...Array(totalSteps - 2).fill('').map((_, index) => lower + (increment * (index + 1))), upper];
};

export default steps;
